import React, { useEffect, useRef } from 'react';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import supersetService from '../../services/superset/superset.service';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MasterSidebar from '../../util/MasterSidebar';
import BreadcrumbsPortal from '../../util/BreadcrumbsPortal';
import { Breadcrumb } from 'react-bootstrap';
const SupersetDashboard = _ref => {
  let {
    accountType
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  const supersetContainer = useRef(null);
  const [adminDashboardGuestToken, setAdminDashboardGuestToken, fetchAdminDashboardGuestToken] = supersetService.useFetchAdminDashboardGuestToken();
  useEffect(() => {
    if (adminDashboardGuestToken && supersetContainer.current) {
      embedDashboard({
        id: adminDashboardGuestToken.dashboard_id,
        supersetDomain: adminDashboardGuestToken.domain,
        mountPoint: supersetContainer.current,
        fetchGuestToken: () => adminDashboardGuestToken.token,
        dashboardUiConfig: {
          hideTitle: false,
          hideTab: false,
          hideChartControls: false,
          filters: {
            expanded: true,
            visible: true
          }
        },
        iframeSandboxExtras: ['allow-downloads', 'allow-popups', 'allow-popups-to-escape-sandbox', 'allow-forms']
      });
      const iframe = supersetContainer.current.querySelector('iframe');
      const setViewportHeight = () => {
        if (!supersetContainer.current) return;
        const rect = supersetContainer.current.getBoundingClientRect();
        const availableViewportHeight = Math.max(window.innerHeight - rect.top, 300);
        if (iframe) {
          iframe.style.height = "".concat(availableViewportHeight, "px");
        }
      };
      if (iframe) {
        iframe.style.width = '100%';
        setViewportHeight();
      }
      const onResize = () => setViewportHeight();
      window.addEventListener('resize', onResize);
      const onMessage = event => {
        try {
          var _event$data, _event$data2, _event$data3;
          const allowedOrigin = new URL(adminDashboardGuestToken.domain).origin;
          if (event.origin !== allowedOrigin) return;
          const newHeight = (event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.height) || (event === null || event === void 0 || (_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.dashboardHeight) || (event === null || event === void 0 || (_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.pageHeight);
          if (typeof newHeight === 'number' && iframe) {
            iframe.style.height = "".concat(Math.max(newHeight, 300), "px");
          }
        } catch (_) {
          // ignore parsing/origin errors silently
        }
      };
      window.addEventListener('message', onMessage);
      return () => {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('message', onMessage);
      };
    }
  }, [adminDashboardGuestToken, supersetContainer]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MasterSidebar, {
    accountType: accountType,
    currentPage: "admin_dashboard"
  }), /*#__PURE__*/React.createElement(BreadcrumbsPortal, null, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(user.account_type)
    }
  }, t('home')), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    active: true
  }, t('admin_dashboard')))), /*#__PURE__*/React.createElement("div", {
    className: "superset-container",
    ref: supersetContainer
  }));
};
export default SupersetDashboard;